const stripeSyncIssues = {
  count_one: '<1>{{ count }}</1> issue unresolved',
  count_other: '<1>{{ count }}</1> issues unresolved',

  actions: 'Actions',
  count: '<1>{{count}}</1> unresolved issue(s)',
  createdAt: 'Created at',
  dealer: 'Dealer',
  markAsResolved: 'Mark as Resolved',
  message: 'Message',
  resolved: 'Resolved',
  status: 'Status',
  syncNumber: 'Sync number',
  syncNumberDescription:
    'Incremental counter for the sync attempt in which the issue was detected.',
  title: 'Stripe sync issues',
  updatedAt: 'Updated at',
  unresolved: 'Unresolved',
};

export default stripeSyncIssues;
